class PasswordValidation {
  constructor() { }

  // 길이 8~12자
  isValidLength(password) {
    if (password.length < 8 || password.length > 12) {
      return false;
    }
    return true;
  }
    
  // 영문, 숫자, 특수문자(`~!@#$%^&*|\'";:/?) 혼합
  isMixed(password) {
    const num = password.search(/[0-9]/g);
    const eng = password.search(/[a-z]/gi);
    const spe = password.search(/[`~!@#$%^&*|\\'";:/?]/g);

    if (num < 0 || eng < 0 || spe < 0) {
      return false;
    }
    return true;
  }
    
  // 동일한 문자 3개 이상 금지
  isNotIdenticalConsecutive(password) {
    if (password.length === 0 || /(.)\1\1/.test(password)) {
      return false;
    }
    return true;
  }
    
  // 연속된 영문, 숫자 4개 이상 금지
  isNotConsecutive(password) {
    if (password.length === 0) {
      return false;
    }

    for (let i = 0; i < password.length - 3; i++) {
      const char1 = password[i];
      const char2 = password[i + 1];
      const char3 = password[i + 2];
      const char4 = password[i + 3];

      const charCode1 = char1.charCodeAt(0);
      const charCode2 = char2.charCodeAt(0);
      const charCode3 = char3.charCodeAt(0);
      const charCode4 = char4.charCodeAt(0);

      if ((charCode1 + 1 === charCode2 && charCode2 + 1 === charCode3 && charCode3 + 1 === charCode4) // 오름차순
        || (charCode1 === charCode2 + 1 && charCode2 === charCode3 + 1 && charCode3 === charCode4 + 1)) { // 내림차순
        if ((utils.isOnlyEng(char1) && utils.isOnlyEng(char2) && utils.isOnlyEng(char3) && utils.isOnlyEng(char4)) // 연속된 문자가 모두 영문이거나
          || (utils.isOnlyDigit(char1) && utils.isOnlyDigit(char2) && utils.isOnlyDigit(char3) && utils.isOnlyDigit(char4))) { // 숫자인 경우만 해당(ascii 코드 상 연속이지만 영문이나 숫자가 아닌 경우는 제외)
          return false;
        }
      }
    }

    return true;
  }
    
  // 비밀번호 확인
  isEqual(password, passwordCheck) {
    if (password.length === 0 || password !== passwordCheck) {
      return false;
    }
    return true;
  }
}

export default PasswordValidation;